import React from 'react';
import { Link } from 'react-router-dom';
import './Css/NotFound.css';

export const NotFound = () => {
  return (
    <div className="not-found">
      <div className="stars"></div>
      <div className="central-body">
        <div className="error-number">
          <span>4</span>
          <div className="circle-404">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <span>4</span>
        </div>
        <h2>Page Not Found</h2>
        <p>Looks like you've ventured too far... <br/> The page you're seeking has drifted into the unknown.</p>
        <div className="btn-group">
          <Link to="/" className="home-button">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            Take me back to Home
          </Link>
        </div>
      </div>
      <div className="objects">
        <div className="rocket">
          <div className="rocket-body">
            <div className="body"></div>
            <div className="fin fin-left"></div>
            <div className="fin fin-right"></div>
            <div className="window"></div>
          </div>
          <div className="exhaust-flame"></div>
        </div>
        <div className="earth-moon">
          <div className="planet">
            <div className="shadow"></div>
          </div>
        </div>
        <div className="astronaut">
          <div className="head"></div>
          <div className="arm arm-left"></div>
          <div className="arm arm-right"></div>
          <div className="body">
            <div className="panel"></div>
          </div>
          <div className="leg leg-left"></div>
          <div className="leg leg-right"></div>
          <div className="schoolbag"></div>
        </div>
      </div>
    </div>
  );
} 
